/**
 * Coerce values passed into react-intl placeholders / React text nodes.
 * API data sometimes stores display names as locale-keyed objects; plain objects
 * would otherwise flow into FormattedMessage and crash rendering.
 */
export function toSafeIntlStringValue(value: unknown, locale?: string): string {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'object') {
    const o = value as Record<string, unknown>;
    const loc = locale && typeof locale === 'string' ? locale.trim().slice(0, 2).toLowerCase() : '';
    if (loc && typeof o[loc] === 'string') return o[loc];
    if (typeof o.en === 'string') return o.en;
    if (typeof o.fi === 'string') return o.fi;
    if (typeof o.sv === 'string') return o.sv;
  }
  return '';
}
